skrilla.controller('withdrawalsCtrl', function ($scope, searchService, queryService, paginationService, cacheService, modalService, currencyService, $stateParams, srefService, withdrawalService) {
    $scope.key = "withdrawals";
    $scope.pageKey = "queryWithdrawals";

    $scope.withdrawals = [];
    $scope.queryOverride = {}
    $scope.userId = $stateParams.userId;
    if ($scope.userId !== undefined) {
        $scope.queryOverride = {userId: $scope.userId}
    }

    $scope.getFtdTenure = function (ftdTenure) {
        if (ftdTenure === null) return ""
        if (ftdTenure < 1000) return ftdTenure
        return "999+"
    }

    $scope.getColour = function (withdrawal) {
        switch (withdrawal.status) {
            case "DECLINED":
                return "light-red";
            case "PARTIALLY_PAID":
                return "light-orange";
            case "PAID":
                return "light-green";
            case "APPROVED":
                return "light-blue";
            default :
                return "";
        }
    }

    $scope.open = function (withdrawal) {
        srefService.go("withdrawalDetails", {id: withdrawal.id});
    }


    $scope.clicked = function (withdrawal) {
        withdrawal.selected = !withdrawal.selected
    };


    $scope.withdrawalsToProcess = []
    $scope.addToAba = function () {
        if ($scope.withdrawals.some(it => it.selected && withdrawalService.blockedByProfileTag(it))) {
            alert('You can not approve the withdrawal of a punter with a compliance review or bet check required tag');
            return;
        }

        if ($scope.withdrawals.some(it => it.selected && it.externalType !== 'AUD_BANK_ACCOUNT')) {
            alert('You can not add non AUD bank account withdrawals to an ABA file');
            return;
        }
        modalService.confirm("Are you sure you'd like to add these withdrawals to the ABA file for withdrawal of the requested amount?", async function () {
            $scope.withdrawalsToProcess = $scope.withdrawals
                .filter(it => it.selected)
            if($scope.withdrawalsToProcess.length !== 0){
                $scope.loading = true;
                addToAba(0)
            }
        });
    }

    function addToAba(i) {
        const withdrawal = $scope.withdrawalsToProcess[i];
        const amountToPay = withdrawal.requestedAmount;
        searchService.put(`withdrawals/${withdrawal.id}/addToABA`, {amountToPay}).then(function(r){
            if(i < $scope.withdrawalsToProcess.length -1){
                addToAba(i + 1)
            }
            else{
                $scope.loading = false;
            }
        })
    }

});

